import Limiter from './limiter';
import MultibandCompressor from './multibandCompressor';
import config from 'app-core/config';
import Comporessor from './Compressor.vue';
import Equalizer from './Equalizer.vue';
import IrConvolutionReverb from './irConvolutionReverb';
import AutoGainControl from './autoGainControl';
import DuckerV2 from './ducker_v2';
import DynamicEq from './DynamicEq.vue';

const plugins = [
	{ id: 'equalizer', icon: 'fas fa-sliders-h', name: () => config.getVueApp().$tCaption('Equalizer'), init: (opts) => Equalizer.wapiInstance({ ...opts, component: Equalizer }) },
	{ id: 'compressor', icon: 'fas fa-compress-arrows-alt', name: () => config.getVueApp().$tCaption('Compressor'), init: (opts) => Comporessor.wapiInstance({ ...opts, component: Comporessor }) },
	{ id: 'multibandCompressor', icon: 'fas fa-compress', name: () => config.getVueApp().$tCaption('Multiband compressor'), init: (opts) => new MultibandCompressor(opts) },
	{ id: 'limiter', icon: 'fas fa-tachometer-alt', name: () => config.getVueApp().$tCaption('Limiter'), init: (opts) => new Limiter(opts) },
	{ id: 'irConvolutionReverb', icon: 'fas fa-bullseye', name: () => 'IR Convolution Reverb', init: (opts) => new IrConvolutionReverb(opts) },
	{ id: 'autoGainControlV2', icon: 'fas fa-tower-broadcast', name: () => 'Automatic Gain Control', init: (opts) => new AutoGainControl(opts) },
	{ id: 'duckerV2', icon: 'fas fa-arrow-down-up-across-line', name: () => 'Ducker', init: (opts) => new DuckerV2(opts), supportSidechain: true },
	{ id: 'dynamicEq', icon: 'fas fa-sliders-h', name: () => 'Dynamic Equalizer', init: (opts) => DynamicEq.wapiInstance({ ...opts, component: DynamicEq }) },
];

async function getPlugin(id, opts) {
	const item = this.getPluginItem(id);
	const instance = item?.init({ ...opts, isDebug: __DEBUG__ });
	const pipeline = await instance?.getAudioPipeline({ ...opts, isDebug: __DEBUG__ });
	return { ...item, instance, pipeline };
}

function getPluginItem(id) {
	return plugins.filter(f => f.id === id)[0];
}

export default {
	plugins,
	getPlugin,
	getPluginItem
}